import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";

export const CreateSimulationButton: React.FC<{
  size?: "sm";
  disabled?: boolean;
  onClick: () => void;
}> = ({ size, disabled = false, onClick }) => (
  <Button
    dataLoc="simulations-create-simulation-button"
    disabled={disabled}
    iconLeft={faPlus}
    size={size}
    variant="secondary"
    onClick={onClick}
  >
    Create simulation
  </Button>
);
